interface Ready {
  kind: 'ready';
}

export const ready = (): Ready => ({ kind: 'ready' });

export type State = Ready;
